import riverstoneResidenceImg from "../../assets/riverstone-residence/riverstone-residence.jpg";
import graphiteKitchenImg from "../../assets/riverstone-residence/graphite-kitchen.jpg";
import materialDetailImg from "../../assets/riverstone-residence/material-detail.jpg";
import modularKitchenImg from "../../assets/ardra-wardrobe-system.jpg";
// import warmKitchenImg from "../../assets/riverstone-residence/warm-kitchen.png";
import siteExecutionImg from "../../assets/riverstone-residence/graphite-kitchen.jpg";

const RiverstoneResidence = {
    title: "Riverstone Residence",
    category: "Interior Design / 4BHK Apartment",
    facts: [
      { label: "Location", value: "Baner, Pune" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "1,850 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Full Interiors" },
    ],
    heroImage: riverstoneResidenceImg,
    heroAlt: "Riverstone Residence interior in Baner, Pune",
    overview:
      "A sophisticated 4BHK apartment interior designed with contemporary aesthetics, efficient kitchen design, and thoughtfully curated living spaces. The project emphasizes modern functionality combined with a refined material palette.",
    fullbleedImage: graphiteKitchenImg,
    fullbleedAlt: "Riverstone Residence kitchen design",
    fullbleedQuote: "Modern design transforms spaces into refined, functional living environments.",
    chapters: [
      {
        eyebrow: "01 - Design Vision",
        title: "Contemporary Living",
        body: "The apartment design combines modern aesthetics with practical functionality, creating spaces that are both beautiful and livable for daily use.",
        image: riverstoneResidenceImg,
        alt: "Riverstone Residence main interior",
      },
      {
        eyebrow: "02 - Kitchen Design",
        title: "Modern Culinary Hub",
        body: "The kitchen features modular design, efficient workflow, quality materials, and modern appliances that make cooking and daily activities seamless.",
        image: graphiteKitchenImg,
        alt: "Riverstone Residence kitchen",
      },
      {
        eyebrow: "03 - Living Spaces",
        title: "Comfortable Areas",
        body: "Living and dining zones are thoughtfully designed with proper lighting, good proportions, and furnishings that support everyday comfort and entertaining.",
        image: modularKitchenImg,
        alt: "Riverstone Residence living area",
      },
      {
        eyebrow: "04 - Finishing Details",
        title: "Refined Execution",
        body: "Materials, colors, and finishes are carefully selected to create a unified, sophisticated aesthetic that enhances the comfort and functionality of the entire space.",
        image: materialDetailImg,
        alt: "Riverstone Residence refined execution detail",
      },
    ],
    gallery: [
      {
        image: riverstoneResidenceImg,
        alt: "Riverstone Residence living interior with contemporary furniture",
        caption: "Contemporary living interior with refined furniture planning",
      },
      {
        image: graphiteKitchenImg,
        alt: "Graphite kitchen view",
        caption: "Graphite kitchen with a clean modern palette",
      },
      {
        image: modularKitchenImg,
        alt: "Wardrobe and modular storage detail",
        caption: "Modular storage detail with a precise finish",
      },
      // {
      //   image: warmKitchenImg,
      //   alt: "Living area",
      //   caption: "Comfortable living and dining space",
      // },
      {
        image: materialDetailImg,
        alt: "Riverstone Residence material and finish detail",
        caption: "Material palette and finish detail",
      },
      {
        image: siteExecutionImg,
        alt: "Riverstone Residence kitchen execution detail",
        caption: "Kitchen execution and finishing detail",
      },
    ],
  };

export default RiverstoneResidence;
